module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0081.jpg?v=9a88d24c";